import Cookies from "universal-cookie";

const cookies = new Cookies();

const defaultOptions = {
  path: "/",
  sameSite: "strict",
  secure: window.location.protocol === "https:",
};

export function setCookie(name, value, options = {}) {
  cookies.set(name, value, {
    ...defaultOptions,
    ...options,
  });
}

export function getCookie(name) {
  return cookies.get(name);
}

export function removeCookie(name, options = {}) {
  cookies.remove(name, {
    ...defaultOptions,
    ...options,
  });
}

export function hasCookie(name) {
  return cookies.get(name) !== undefined;
}
